import React, { useMemo, useState } from 'react';
import { Form, Stack } from 'react-bootstrap';
import {
  CareProgressBadgeType,
  type CareProgressRowData,
} from '../../../../Table/components/CareProgress/types';
import CareMapprPopup from '../../../../Popup/CareMapprPopup';
import { convertToFormattedDateString } from '../../../../../helpers';

interface ScriptWrittenFieldProps {
  scriptWrittenValue?: CareProgressRowData[];
}
const ScriptWrittenField = ({
  scriptWrittenValue,
}: ScriptWrittenFieldProps) => {
  const [openScript, setOpenScript] = useState(false);

  const latestScript: CareProgressRowData | null = useMemo(() => {
    if (scriptWrittenValue && scriptWrittenValue.length > 0) {
      scriptWrittenValue.sort(
        (a, b) =>
          new Date(b.event_date).getTime() - new Date(a.event_date).getTime(),
      );
      return scriptWrittenValue[0];
    }
    return null;
  }, []);

  const scriptWrittenStarted: boolean = useMemo(
    () =>
      latestScript?.detail?.status === CareProgressBadgeType.COMPLETED ||
      latestScript?.detail?.status === CareProgressBadgeType.IN_PROGRESS,
    [latestScript],
  );

  return (
    <>
      <Stack direction="horizontal" className="script-written-row my-3">
        <Form.Label className="footer-label mb-0">Script written</Form.Label>
        <div className="d-flex gap-1 align-items-center width-90">
          <Form.Label className="script-written-not-started mb-0">
            {scriptWrittenStarted ? 'Yes' : 'No'}
          </Form.Label>
          {scriptWrittenStarted && (
            <span
              className="view-script-label"
              onClick={() => setOpenScript(true)}
            >
              View script
            </span>
          )}
        </div>
        {scriptWrittenStarted && latestScript?.event_date ? (
          <span className="pmm-date pdf-font-size-25">
            {convertToFormattedDateString(latestScript?.event_date)}
          </span>
        ) : (
          <span className="pmm-date pdf-font-size-25" />
        )}
      </Stack>
      <CareMapprPopup
        show={openScript}
        onHide={() => setOpenScript(false)}
        title={undefined}
        titleIcon={undefined}
      >
        Script
      </CareMapprPopup>
    </>
  );
};

export default ScriptWrittenField;
